export default api => ({
    exports: params => api.get('/audit/exports', params),
    stats: params => api.get('/audit/exports/stats', params),
})
